__turbopack_context__.v({
  "badge": "EXHBzq_badge",
  "info": "EXHBzq_info",
  "success": "EXHBzq_success",
  "urgent": "EXHBzq_urgent",
  "warning": "EXHBzq_warning",
});
